var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "printing-template directions-template" },
    [
      _c("h2", { domProps: { innerHTML: _vm._s(_vm.contentTitle) } }),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("img", {
        attrs: {
          alt: "Map print view",
          width: "auto",
          height: "400",
          src: _vm.mapViewImage
        }
      }),
      _vm._v(" "),
      _vm._l(_vm.localMapViewData.places, function(place, index) {
        return [
          _c(
            "div",
            { key: index },
            [
              _c("h5", [_vm._v(_vm._s(place.placeName))]),
              _vm._v(" "),
              _vm._l(_vm.localMapViewData.polygons, function(
                polygon,
                polygonIndex
              ) {
                return [
                  _vm.hasAsCenter(place, polygon)
                    ? [
                        _c(
                          "div",
                          {
                            key: polygonIndex,
                            staticStyle: { "padding-left": "10px" }
                          },
                          [
                            _c(
                              "span",
                              {
                                style: { background: polygon.properties.color }
                              },
                              [
                                _c(
                                  "b",
                                  {
                                    style: {
                                      color: _vm.polygonAreaTextColor(polygon)
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        polygon.properties.label.replace(
                                          "Polygon",
                                          ""
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("⇒")]),
                            _vm._v(
                              " " +
                                _vm._s(polygon.properties.area) +
                                " &\n            "
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("global.population")) +
                                  ": " +
                                  _vm._s(polygon.properties.total_pop)
                              )
                            ])
                          ]
                        )
                      ]
                    : _vm._e()
                ]
              }),
              _vm._v(" "),
              _c("br")
            ],
            2
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29719452", { render: render, staticRenderFns: staticRenderFns })
  }
}